<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.expenses') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header
              :title="$t('message.vendor')"
              :subtitle="$t('series.ex') + ' ' + nextExCode"
            />
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.storecompanyperson') }}</label>
                    <selectize
                      v-model="form.pickedVendorId"
                      :default="form.defaultVendorId"
                      :updateoption="form.updateOptionVendor"
                      :options="form.optionVendors"
                      :multiple="false"
                      :create="true"
                      :loading="form.loadingVendor"
                      :placeholder="$t('placeholder.selectorcreate')"
                      @add="onAddedVendor" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="form.pickedVendorId"
              class="form-row">
              <div class="col-md-6">
                <div
                  class="form-group row"
                  style="height: 100%;">
                  <div class="col-md-12">
                    <label>{{ $t('message.address') }}</label>
                    <textarea
                      v-model="form.vendor.address"
                      class="form-control"
                      style="height: calc(100% - 37px);"/>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.tel') }}</label>
                    <input
                      v-model="form.vendor.tel"
                      type="text"
                      class="form-control">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.email') }}</label>
                    <input
                      v-model="form.vendor.email"
                      type="text"
                      class="form-control">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.taxpayerno') }}</label>
                    <input
                      v-model="form.vendor.tax_id"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header
              :title="$t('message.infopayment')"
            />
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.expclaimtype') }}</label>
                    <selectize
                      v-model="form.pickedDescription"
                      :default="form.defaultDescription"
                      :options="form.optionDescriptions"
                      :validation="form.trickDescriptionValidation"
                      :multiple="false"
                      :create="true"
                      :placeholder="$t('placeholder.selectorcreate')" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('apps.expenses.message.expensetype') }}</label>
                    <BaseDropdown
                      v-model="form.expense_type"
                      :options="expenseOptions"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.date') }}</label>
                    <BaseInputDatePicker
                      v-model="form.created_at"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.paidamount', {string: currency}) }}</label>
                    <input
                      v-model="form.payment_amount"
                      type="text"
                      class="form-control text-select-all"
                      @keypress="numberOnly"
                      @keyup="form.payment_amount = setToValidNumber(form.payment_amount)"
                      @blur="form.payment_amount = setToCustomDigitsNumber(form.payment_amount)">
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.taxes') }}</label>
                    <MultipleSelect
                      v-model="form.taxIds"
                      :options="taxOptions"
                      :multiple="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col">
                    <b-form-textarea
                      :placeholder="$t('placeholder.note')"
                      v-model="form.note"
                      style="min-height: 126px;"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-md-12 row no-padding no-margin">
                  <div
                    v-if="taxResults.length > 0"
                    class="col-12 row no-margin no-padding">
                    <div class="col-6 no-padding mb-2">
                      {{ $t('message.untaxed') }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(total.untaxed) }}
                    </div>
                  </div>
                  <div
                    v-for="(tax, index) in taxResults"
                    :key="index"
                    class="col-12 row no-margin no-padding"
                  >
                    <div class="col-6 no-padding mb-2">
                      {{ tax.displayText }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(tax.total) }}
                    </div>
                  </div>
                  <div
                    v-if="taxResults.length > 0 && total.payment != total.grand && total.payment != total.untaxed"
                    class="col-12 row no-margin mb-2 no-padding">
                    <div class="col-6 no-padding">
                      {{ $t('message.totalamount') }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(total.payment) }}
                    </div>
                  </div>
                  <div class="col-12 row no-margin no-padding">
                    <div class="col-6 no-padding">
                      {{ $t('message.netpayable') }}
                    </div>
                    <div class="col-6 no-padding text-right">
                      <span class="text-underline-border">
                        {{ getNumber(total.grand) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="action-bar">
          <template>
            <div
              v-if="!$store.state.app.loading"
              class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-web"
                @click="save({isCreateAnother: false})">{{ $t('button.save') }}</button>
            </div>
            <div
              v-else
              class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-web"
                disabled><i class="fas fa-spinner spin"/></button>
            </div>
          </template>
        </section>
      </template>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import { getDisplayTaxNameRate, getMasterDataText } from '../../../../helpers'
import MultipleSelect from '@/components/custom/MultipleSelect'

export default {
  components: {
    MultipleSelect,
  },
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedVendorId: null,
        defaultVendorId: null,
        optionVendors: [],
        updateOptionVendor: null,
        loadingVendor: false,
        vendor: {
          address: null,
          tax_id: null,
          email: null,
          tel: null,
        },

        pickedDescription: null,
        defaultDescription: null,
        optionDescriptions: [],
        trickDescriptionValidation: 0,
        created_at: new Date(),
        paid_by: 'shop',
        payment_amount: 0,
        note: '',
        expense_type: null,
        taxIds: [],
      },

      originalForm: null,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      nextExCode: 'getNextExCode',
      currency: 'getCurrency',
      dateformat: 'getDateFormat',
      descriptionLists: 'getExpenseDescriptionLists',
      expenseSetting: 'getExpenseSetting',
      taxes: 'getTaxes',
      vendors: 'getVendors',
      getVendorById: 'getVendorById',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
    }),
    expenseTypes() {
      if (this.expenseSetting && this.expenseSetting.types) {
        return this.expenseSetting.types
      }
      return []
    },
    expenseOptions() {
      return this.expenseTypes
        .filter((type) => type.is_active)
        .map((type) => {
          return {
            text: getMasterDataText(type.name, this.$t),
            value: type.name,
          }
        })
    },
    defaultExpenseType() {
      return this.expenseTypes.find((type) => type.is_default).name
    },
    selectedTaxes() {
      return this.form.taxIds.reduce((acc, cur) => {
        const taxId = cur
        const tax = this.taxes.find((tax) => tax.tax_id == taxId)
        if (tax) {
          acc.push(tax)
        }
        return acc
      }, [])
    },
    taxOptions() {
      return this.taxes
        .filter((tax) => {
          return tax.is_for_expense
        })
        .map((tax) => {
          return {
            value: tax.tax_id,
            text: getDisplayTaxNameRate(getMasterDataText(tax.tax_name, this.$t), tax.amount),
          }
        })
    },
    fakeOrders() {
      return [
        {
          price: this.form.payment_amount,
          taxes: this.selectedTaxes,
        },
      ]
    },
    total () {
      const oders = this.getDataSetOrders(this.fakeOrders)
      return this.getTotal(oders)
    },
    taxResults () {
      const isGroupTaxName = false
      const oders = this.getDataSetOrders(this.fakeOrders)
      return this.getTaxesByOrders(oders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
  },
  methods: {
    ...mapActions([

    ]),
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        newData.push({
          item: null,
          description: null,
          sku_id: null,
          quantity: 1,
          price: item.price,
          discounts: [],
          taxes: item.taxes.map((tax) => ({
            name: tax.tax_name,
            type: tax.type,
            amount: tax.amount,
            form_type: tax.form_type,
            group_name: tax.group_name,
            is_display_fee_result: tax.is_display_fee_result,
            is_for_expense: tax.is_for_expense,
            tax_id: tax.tax_id,
          })),
        })
      }
      return newData
    },
    async onAddedVendor (value) {
      // show loading selectize
      this.form.loadingVendor = true

      // insert new vendor
      let res = await this.$store.dispatch('insertVendor', { name: value })

      if (res.success) {
        let vendor = res.data
        // update option value
        this.form.updateOptionVendor = {
          text: value,
          value: vendor.vendor_id,
          picked: true,
        }
        this.form.optionVendors.push({
          text: value,
          value: vendor.vendor_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingVendor = false
      }
    },
    isValid () {
      if (this.form.pickedDescription == null) {
        return false
      } else {
        if (this.form.pickedDescription.trim().length == 0) {
          return false
        }
      }
      return true
    },
    async save (opt = {}) {
      this.form.trickDescriptionValidation++

      if (!this.isValid()) {
        return
      }

      const orders = this.getDataSetOrders(this.fakeOrders)
      const taxes = orders[0].taxes
      const vendorInfo = this.getVendorById(this.form.pickedVendorId)

      const dataSet = {
        'status': 'padding',
        'description': this.form.pickedDescription,
        'expense_type': this.form.expense_type,
        'created_at': this.form.created_at ? this.form.created_at.toISOString() : this.moment().toISOString(),
        'paid_by': this.form.paid_by,
        'payment': {
          'price': parseFloat(this.form.payment_amount),
          'sub': this.total.untaxed,
          'tax': this.total.taxes.all,
          'total': this.total.payment,
          'amount': this.total.grand,
        },
        'note': this.form.note.trim() ? this.form.note.trim() : null,
        'vendor_id': this.form.pickedVendorId,
        'taxes': taxes,
        'report': {
          'sub_total': this.total.untaxed,
          'tax_total': this.total.taxes.all,
          'grand_total': this.total.grand,
          'category_id': null,
          'category_name': this.form.expense_type,
          'vendor_id': this.form.pickedVendorId,
          'vendor_name': vendorInfo ? vendorInfo.vendor_name : null,
        },
      }

      // update vendor
      const dataSetVendorUpdate = this.getDataSetPartnerUpdate('vendor', this.form.pickedVendorId, this.form.vendor, this.vendors)
      if (dataSetVendorUpdate !== null) {
        await this.$store.dispatch('updateVendor', dataSetVendorUpdate)
        await this.$store.dispatch('getVendors')
      }

      const res = await this.$store.dispatch('insertExpense', dataSet)

      if (res.success) {
        const newExp = res.data.expense
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newExp.ex_code }),
          color: 'success',
          icon: 'cloud',
        })

        if (!opt.isCreateAnother) {
          return this.$router.push({
            name: 'ExpensesClaimEdit',
            query: {
              ex_id: newExp._id,
              ex_code: newExp.ex_code,
              ignoreDiscardAlert: true,
            },
          })
        } else {
          // clear form
          this.clearForm()
        }
      }
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      // get next code
      await this.$store.dispatch('getNextExCode')

      that.ready = true

      // scroll to top
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    descriptionLists: function (after, before) {
      let lists = after
      this.form.optionCustomers = []
      for (let i in lists) {
        let item = lists[i]
        this.form.optionDescriptions.push({
          text: item.description,
          value: item.description,
        })
      }
    },
    vendors: function (after, before) {
      this.form.optionVendors = []
      for (let i in after) {
        let vendor = after[i]
        this.form.optionVendors.push({
          text: vendor.vendor_name,
          value: vendor.vendor_id,
        })
      }
    },
    'form.pickedVendorId': {
      handler: function (after) {
        let vendor_id = after
        let vendorInfo = this.getVendorById(vendor_id)

        this.form.vendor.address = null
        this.form.vendor.tax_id = null
        this.form.vendor.email = null
        this.form.vendor.tel = null

        if (vendorInfo) {
          this.form.vendor.address = vendorInfo.address
          this.form.vendor.tax_id = vendorInfo.tax_id
          this.form.vendor.email = this.getPartnerContact(vendorInfo.contacts).email
          this.form.vendor.tel = this.getPartnerContact(vendorInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat
    // set payment_amount
    this.form.payment_amount = this.setToCustomDigitsNumber(this.form.payment_amount)
    await Promise.all([
      this.$store.dispatch('getNextExCode'),
      this.$store.dispatch('getExpenseDescriptionLists'),
      this.$store.dispatch('getTaxes'),
      this.$store.dispatch('getVendors'),
    ])
    // set originalForm
    this.originalForm = _.cloneDeep(this.form)
    // set default form
    this.form.expense_type = this.defaultExpenseType
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.expenses.title'),
      current: {
        app_name: 'expenses',
        app_id: 6,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 1,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearExpenseDescriptionLists'])
  },
}
</script>

<style scoped>
  .scheduled {
    position: relative;
  }
  .scheduled .overlay {
    display: none;
  }
  .scheduled.disabled .overlay {
    position: absolute;
    width: -webkit-calc(100% - 30px);
  	width:    -moz-calc(100% - 30px);
  	width:         calc(100% - 30px);
    height: 38px;
    top: 32px;
    left: 15px;
    z-index: 1;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/expenses/ex/New.vue